import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import EditForm from './components/form';
import  './main.less';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content cpl-rules-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='campaigns/' className="link">
						{ props.intl('Return to campaigns list') }
					</Link>
				</div>
			</div>
			<div className="container__content-body">
				<div className="form-container">
					<EditForm
						{...props}
						location_path={props.router.getCurrentLocation().pathname}
						initialValues={{
							campaign_id: props.params.id,
							currency: props.campaignCurrencySelector(props.params.id)
						}}
					/>
				</div>
			</div>
		</div>
	</Animate>
), 'campaignsEdit');

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		campaignCurrencySelector: selectors.getCampaignCurrencySelector(state),
		activePayoutCurrencies: selectors.getActivePayoutCurrencies(state),
		error: false,
		can: selectors.getCan(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/payout-editor/main.js